import React, {useEffect} from 'react';
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";
import StripePayment from "../Payments/StripePayment";

const PurchaseStep = ({subscription}) => {

    const {amount, setAmount} = useRegistrationSteps();

    useEffect(() => {
        setAmount(parseFloat(subscription.price).toFixed(2));
    }, [subscription]);

    return (
        <div>
            <div className="mb-8">
                <div className="border-b w-full text-left">
                    <div className="font-bold">{subscription.name}</div>
                    <div>{subscription.description}</div>
                </div>
                <div className="font-bold text-right">{amount} €</div>
            </div>

            <StripePayment />

        </div>
    );
};

export default PurchaseStep;